import { useParams } from "react-router-dom";
import { Flex, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import { ApprobationView } from "./ApprobationView";

export function ApprobationById() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const proofId = Number(id);

  if (!id || isNaN(proofId)) {
    return (
      <Flex
        p="4"
        justify="center"
        align="center"
        style={{ minHeight: "200px" }}
      >
        <Text color="gray" size="3">
          {t("approbation.proofNotFound")}
        </Text>
      </Flex>
    );
  }

  return <ApprobationView proofId={proofId} />;
}
